import { IBoolResult } from '@/types/dto';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/admin/agent/actions/install';

interface IRequest {
  securityKey: string;
  userName: string;
  password: string;
}

export default {
  install(hostName: string, nodeName: string, isHongKong: boolean, req: IRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
        utils.loading(false);
      });
  },
};
